import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./MenuPage.css";

const MenuPageOrder = () => {
  const location = useLocation();
  const { storeName, menuItems } = location.state || {};
  const navigate = useNavigate();

  const [selectedFoodItem, setSelectedFoodItem] = useState(null);
  const [quantities, setQuantities] = useState({});
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");

  const handleFoodItemPress = (item) => {
    setSelectedFoodItem((prev) => (prev?.id === item.id ? null : item));
  };

  const handleQuantityChange = (itemId, quantity) => {
    setQuantities((prev) => ({
      ...prev,
      [itemId]: quantity,
    }));
  };

  const getPriceInCents = (price) => {
    if (typeof price === "string") {
      return Math.round(parseFloat(price.replace("$", "")) * 100);
    } else if (typeof price === "number") {
      return Math.round(price * 100);
    }
    return 0;
  };

  const handleOrder = () => {
    if (!customerName || !customerPhone) {
      alert("Please enter your name and phone number.");
      return;
    }

    const items = menuItems
      .filter((item) => quantities[item.id] > 0)
      .map((item) => ({
        name: item.name,
        quantity: quantities[item.id].toString(),
        base_price_money: {
          amount: getPriceInCents(item.price),
          currency: "USD",
        },
      }));

    const totalAmount = items.reduce(
      (sum, item) => sum + item.quantity * (item.base_price_money.amount / 100),
      0
    );

    if (items.length > 0) {
      navigate("/order-summary", {
        state: {
          selectedItems: items,
          totalAmount,
          customer: {
            name: customerName,
            phone: customerPhone,
          },
        },
      });
    } else {
      alert("No items selected for order.");
    }
  };

  return (
    <div className="menu-container">
      <div className="banner">
        <h2>{storeName} Menu</h2>
      </div>

      <div className="customer-info">
        <label>
          Name:
          <input
            type="text"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
            placeholder="Your name"
          />
        </label>
        <label>
          Phone Number:
          <input
            type="tel"
            value={customerPhone}
            onChange={(e) => setCustomerPhone(e.target.value)}
            placeholder="123-456-7890"
          />
        </label>
      </div>

      <p className="intro">Click on Item to see Detail</p>

      <div className="menu-section">
        <h3>Food</h3>
        {menuItems.map((item) => (
          <div key={item.id} className="menu-item">
            <div className="menu-header" onClick={() => handleFoodItemPress(item)}>
              <span>{item.name}</span>
              <span>{item.price}</span>
            </div>
            <div className="quantity-picker">
              <span>Qty:</span>
              {[...Array(10).keys()].map((val) => {
                const q = val + 1;
                return (
                  <button
                    key={q}
                    className={`quantity-btn ${
                      quantities[item.id] === q ? "selected" : ""
                    }`}
                    onClick={() => handleQuantityChange(item.id, q)}
                  >
                    {q}
                  </button>
                );
              })}
            </div>
            {selectedFoodItem?.id === item.id && (
              <div className="item-details">
                {item.imageUrl && (
                  <img
                    src={item.imageUrl}
                    alt={item.name}
                    className="item-image"
                  />
                )}
                <p className="item-description">{item.description}</p>
              </div>
            )}
          </div>
        ))}
        <button className="checkout-btn" onClick={handleOrder}>
          Checkout
        </button>
      </div>
    </div>
  );
};

export default MenuPageOrder;
